import { SubmitNoteButtonStyles } from './SubmitNoteButton.types'

const makeStyles = (): SubmitNoteButtonStyles => ({
	noteButton: {
		fontFamily: 'SVFont',
		fontSize: '28px',
		height: '50px',
		marginTop: '20px',
		width: '100%'
	}
})

export default makeStyles
